const closeButtonLabel = "Sluiten";
const nlNL = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  nlNL as default
};
